import { render, staticRenderFns } from "./EditProDialog.vue?vue&type=template&id=3552523e&scoped=true"
import script from "./EditProDialog.vue?vue&type=script&lang=js"
export * from "./EditProDialog.vue?vue&type=script&lang=js"
import style0 from "./EditProDialog.vue?vue&type=style&index=0&id=3552523e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552523e",
  null
  
)

export default component.exports